import styled from "@emotion/styled"
import ButtonRegular from "@/components/composite/ButtonRegular/main"
import ButtonText from "@/components/composite/ButtonText"

export const ButtonConfirm = styled(ButtonRegular)``

export const ButtonDoItLater = styled(ButtonText)`
    width: 100%;
    font-weight: 500;
    cursor: pointer;
`
